import { c as _c } from "react-compiler-runtime";
import useSetUpEmbeddedComments from 'collaboration-sidebar/features/deepCommenting/hooks/useSetUpEmbeddedComments';
import { useCollaborationSidebarState } from '../hooks';
export default function EmbeddedCommentSetup() {
  "use memo";

  const $ = _c(3);
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  let t0;
  if ($[0] !== collaborationSidebarState || $[1] !== onUpdateCollaborationSidebarState) {
    t0 = {
      collaborationSidebarState,
      onUpdateCollaborationSidebarState
    };
    $[0] = collaborationSidebarState;
    $[1] = onUpdateCollaborationSidebarState;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useSetUpEmbeddedComments(t0);
  return null;
}